
const NodeTypes = {
  SPEECH: 'SPEECH',
  SPEECH_OPTION: 'SPEECH_OPTION',
  EXPLORATION: 'EXPLORATION',
  COMBAT: 'COMBAT'
}

export default NodeTypes;